import SharedFileUploaderModal from "Components/FileUploaderModal/FileUploaderModal";
import { useFileUploaderModal } from "./useFileUploaderModal";
import { usePurchaseOrders } from "../../../../usePurchaseOrders";

function FileUploaderModal({ locationId }) {
  const { display, closeModal } = useFileUploaderModal();

  const uploadPath = `${process.env.REACT_APP_API}/api/file/uploadinvoice`;

  const extraFields = { fileTypeName: "Invoice" };
  if (locationId && locationId.length == 24) extraFields.locationId = locationId;

  return (
    <SharedFileUploaderModal
      display={display}
      onClose={closeModal}
      uploadPath={uploadPath}
      extraFields={extraFields}
      title="Upload Invoice Files"
      subtitle="Select invoice files to upload"
      onUploaded={(data) => usePurchaseOrders.getState().attachInvoices(data)}
    />
  );
}

export default FileUploaderModal;
